
export enum DataTypeEnum {
    Double,
    String,

    //new for forms
    Boolean,
    Date
};
